'use client'

export default function GlobalError() {
	return (
		<html lang="ru">
			<head>
				<title>iPort – 500 (ошибка сервера)</title>
				<meta name="robots" content="noindex" />
			</head>
			<body>
				<h1>500. Ошибка сервера</h1>
			</body>
		</html>
	)
}
